export { useMenuGroup_unstable as useMenuGroup } from '@fluentui/react-menu';
